import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { pushDrilldownFilter } from '@src/store/dimensionContainer/actions';
import { applyFilter } from '@src/store/common/actions';
import { useMultiDimensionFilters } from './useMutilDimensionFilters';
import { getFilterFromRules, getRulesFromFilter } from '@src/utils';
import { getFirstAppliedFilter } from '@src/store/common/selectors';
import { checkIfRuleAlreadyExist } from '@src/utils/filter';
import { ZERO } from './constant';

export const useAddGlobalFilter = (dimensions, rowData) => {
  const dispatch = useDispatch();
  let filters = useMultiDimensionFilters(dimensions, rowData);
  const globalFilter = useSelector(getFirstAppliedFilter);

  filters = filters.filter((item) => !checkIfRuleAlreadyExist(globalFilter.rule, item[0]));

  const handleAddGlobalFilter = useCallback(() => {
    // add to breadcrumb
    const crumbRules = getRulesFromFilter(filters, true);
    const crumbFilter = getFilterFromRules(crumbRules, true);
    dispatch(pushDrilldownFilter(crumbFilter.name, crumbFilter.rule));

    // parse and apply filter
    const combinedFilter = [...globalFilter.rule, ...filters];
    const newRules = getRulesFromFilter(combinedFilter, true);
    const newFilter = getFilterFromRules(newRules, true);
    dispatch(applyFilter(newFilter));
  }, [filters, dispatch, globalFilter.rule]);

  if (filters.length === ZERO) {
    return () => {};
  }

  return handleAddGlobalFilter;
};
